import {Image404} from '../ImageLoader';
import DocumentTitle from '../DocumentTitle';
const Page_404 = () => {
    DocumentTitle("CW Creations - Dev Consult Share | 404");
    return(<div className='Page_404'>
           <h2>Page not found</h2>
           <table>
             <tbody>
               <tr>
                 <td><img src={Image404}/></td>
                 <td><img src={Image404}/></td>
                 <td><img src={Image404}/></td>
               </tr>
             </tbody>
           </table>
           <p>You are seeing this page because the URL entered did not equal a valid route.</p>
           </div>);
}

export default Page_404;